import { APIClient } from "../../../helpers/api_helper";

const api = new APIClient();

  export const createInspection = async (data) => {
      try {
        const response = await api.create(`/inspections/add`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getInspections = async () => {
      try {
        const response = await api.get(`/inspections/all`);
        return response;
      } catch (error) {
        throw error;
      }
  };
  export const getInspectionById = async (id) => {
      try {
        const response = await api.get(`/inspections/${id}`);
        return response;
      } catch (error) {
        throw error;
      }
  };
  export const getInspectionByType = async ( category ) => {
      try {
        const response = await api.get(`/inspections/category/${category}`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const updateInspection = async ( id, data) => {
      try {
        const response = await api.put(`/inspections/update/${id}`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const deleteInspection = async (id) => {
    try {
        const response = await api.delete(`/inspections/delete/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
  };
  
  export const valideInspection = async ( id, status) => {
    try {
      const response = await api.put(`/inspections/status/${id}?status=${status}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getUninspectionVehicle = async () => {
    try {
      const response = await api.get(`/vehicles/no-inspections`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const relanceUninspectionVehicle = async () => {
    try {
      const response = await api.get(`/reminders/send`);
      console.log('relance', response)
      return response;
    } catch (error) {
      throw error;
    }
  };